import type { User } from '../types';
import type { B2BBuyer } from '../types/b2b';

/**
 * Where an authenticated session belongs. Mirrors the `redirectTo` the
 * auth-login function returns, so the client falls back to the same
 * destination when no explicit redirect is supplied.
 */
export function getPostLoginPath(user: User | null, buyer: B2BBuyer | null): string {
  if (buyer) return '/b2b';
  if (user?.role === 'super_admin') return '/admin';
  return '/dashboard';
}
